import React, { useState } from "react";
import Fontstyling, { tablestyle } from "../../../components/common/comman";
import {
  GetFileInJsonString,
  DownloadFile,
} from "../../../api/User/fileReadWriteApi";
import { useEffect } from "react";
import { Link, Route, Routes } from "react-router-dom";
import MuiTable from "../../../components/common/MuiTable";
import { Badge } from "react-bootstrap";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { useSelector } from "react-redux";
import { DateRangePicker } from "rsuite";
import "./style.css";
import eyesolid from "../../../assets/icon/eye-solid.svg";
import { FiDownload } from "react-icons/fi";
// import MaterialTable from "material-table";
import MaterialTable from "@material-table/core";

export const ApproveCarrierFile = ({ navigate }) => {
  const [data, setData] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("-1");
  // const [isSelectDateClicked, setIsSelectDateClicked] = useState(false);
  // const [dateRange, setDateRange] = useState([
  //   {
  //     startDate: new Date("04/05/2023"),
  //     endDate: addDays(new Date(), 10),
  //     key: "selection",
  //   },
  // ]);
  const [dateRange, setDateRange] = useState([]);
  const UD_id = useSelector((state) => state.userDetails.value?.UD_id);
  // console.log('data',data)
  const columns = [
    {
      title: "File Name",
      render: (rowData) => (
        <Link to={`${rowData.FileName}`} style={{ textDecoration: "none" }}>
          {rowData.FileName.split("/")[rowData.FileName.split("/").length - 1]}
        </Link>
      ),
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData =
          rowData.FileName.split("/")[rowData.FileName.split("/").length - 1];
        return processedData.toLowerCase().includes(searchText);
      },
    },
    { title: "Date", field: "FileUploadedDate", type: "date" },
    { title: "Client Name", field: "ClientName" },
    { title: "Carrier Name", field: "CarrierName" },
    { title: "File Category", field: "CategoryName" },
    { title: "File Type", field: "FileTypeName" },
    {
      title: "Status",
      align: "center",
      render: (rowData) => {
        let badgeColor;
        switch (rowData.FileIsApproved) {
          case 1:
            badgeColor = "primary";
            break;
          case "Rejected":
            badgeColor = "danger";
            break;
          case 0:
            badgeColor = "warning";
            break;
        }
        return (
          <Badge
            pill
            className="fw-normal py-1 px-3"
            bg={badgeColor}
            style={{ fontSize: "10px" }}
          >
            {rowData.FileIsApproved === 0 ? "Pending" : "Approved"}
          </Badge>
        );
      },
    },
    {
      title: "Actions",
      maxWidth: "90px",
      cellStyle: { textAlign: "center", minWidth: "80px" },
      headerStyle: { textAlign: "center" },
      sorting: false,
      render: (rowData) => (
        <div className="d-flex align-items-center justify-content-evenly">
          <Link
            to={`${rowData.FileName}`}
            style={{ textDecoration: "none" }}
            className="p-2"
          >
            <img
              src={eyesolid}
              width="12"
              alt="eye icon"
              className="cursor-pointer"
            />
          </Link>
          <div
            className="cursor-pointer p-2"
            onClick={() => {
              DownloadFile(rowData.FileReadWriteID).then((res) => {
                const url = URL.createObjectURL(res.data);
                const link = document.createElement("a");
                link.href = url;
                link.download = `${
                  rowData.FileName.split("/")[
                    rowData.FileName.split("/").length - 1
                  ]
                }`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              });
            }}
          >
            <FiDownload size={12} />
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    // if (!isSelectDateClicked) GetAprovedFilteData();
    GetAprovedFilteData();
  }, [selectedStatus, dateRange]);

  useEffect(() => {
    if (isUpdate) {
      GetAprovedFilteData();
      setIsUpdate(false);
    }
  }, [isUpdate]);

  const GetAprovedFilteData = () => {
    setIsLoading(true);

    const getDateInFormat = (unformattedDate) => {
      if (!unformattedDate) return unformattedDate;

      const dateObj = new Date(unformattedDate);

      const year = dateObj.getFullYear().toString();
      const month = (dateObj.getMonth() + 1).toString();
      const date = dateObj.getDate().toString();

      return `${year}-${month.length === 1 ? "0" + month : month}-${
        date.length === 1 ? "0" + date : date
      }`;
    };

    const startDate = dateRange ? getDateInFormat(dateRange[0]) : null;
    const endDate = dateRange ? getDateInFormat(dateRange[1]) : null;

    GetFileInJsonString(UD_id, selectedStatus, startDate, endDate)
      .then((res) => {
        if (res?.status === 200 || res?.status === 204) {
          setData(res.data);
          setIsLoading(false);
        }
      })
      .catch((err) => setIsLoading(false));
  };

  return (
    <Routes>
      <Route
        index
        element={
          <>
            <div className="d-flex align-items-center justify-content-between pb-4">
              <h5 className="mb-0 mt-0" style={{ ...Fontstyling.heading }}>
                <label style={{ fontSize: 15 }}>Approve File Here</label>
              </h5>
              <div className="d-flex align-items-center gap-2 container-filter">
                <DateRangePicker
                  showOneCalendar
                  onChange={(value) => {
                    setDateRange(value);
                  }}
                  value={dateRange}
                  placeholder={"Select Date"}
                  size="sm"
                  disabled={isLoading}
                />
                <select
                  className="form-select rounded-0 py-1 text-nowrap"
                  style={Fontstyling.label}
                  name="role"
                  value={selectedStatus}
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                  }}
                  disabled={isLoading}
                >
                  {["All", "Pending", "Approved"].map((item, index) => (
                    <option key={index} value={index - 1}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div>
              <MaterialTable
                isLoading={isLoading}
                columns={columns}
                data={data}
                style={{ ...tablestyle.tabledata }}
                options={{
                  sorting: false,
                  draggable: false,
                  actionsColumnIndex: -1,
                  pageSize: 10,
                  paging: data.length > 10,
                  paginationType: "normal",
                  search: true,
                  filtering: false,
                  showTitle: false,
                  toolbar: true,
                  headerStyle: {
                    padding: "0px",
                    backgroundColor: "#18252D",
                    color: "#EEF0E2",
                    textTransform: "capitalize",
                    fontSize: "11px",
                    fontFamily: "Arial",
                    fontWeight: "700",
                    border: "1px solid #dee2e6",
                    whiteSpace: "nowrap",
                    zIndex: 0,
                  },
                  actionsCellStyle: {
                    padding: "0px",
                    maxWidth: "20px",
                  },
                }}
              />
            </div>
          </>
        }
      />
      {data.map((object, index) => {
        return (
          <Route
            key={index}
            path={`${object.FileName}`}
            element={
              <MuiTable
                navigate={navigate}
                setIsUpdate={setIsUpdate}
                object={object}
              />
            }
          />
        );
      })}
    </Routes>
  );
};

export default ApproveCarrierFile;
